class ChurnZeroService {
  constructor() {
    this.appKey = process.env.CHURNZERO_APP_KEY;
    this.isInitialized = false;
    this.appKeySet = false;
    this.isUserIdentified = false;
    this.companyId = null;
    this.isExcludedCompany = false;
  }

  initialize() {
    if (this.isInitialized) {
      return true;
    }

    if (!this.appKey) {
      console.warn('ChurnZero: Missing app key');
      return false;
    }

    if (window.ChurnZero) {
      if (!this.appKeySet) {
        window.ChurnZero.push(['setAppKey', this.appKey]);
        this.appKeySet = true;
        console.log('ChurnZero: App key set');
      }
      this.isInitialized = true;
      console.log('ChurnZero: Initialized');
      return true;
    } else {
      console.warn('ChurnZero: Script not loaded yet');
      return false;
    }
  }

  /**
   * Identify user with ChurnZero and set user attributes
   * @param {string} accountExternalId - External ID of the account/company
   * @param {string} contactExternalId - External ID of the contact/user
   * @param {Object} user - User object with properties to set as attributes
   */
  identifyUser(accountExternalId, contactExternalId, user) {
    if (!this.initialize() || this.isUserIdentified) return false;

    this.companyId = user?.company?.id ?? null;
    this.isExcludedCompany =
      !user?.company ||
      user?.paywall?.is_watchdog ||
      user?.company?.company_type !== 'broker' ||
      this.companyId === 1;

    if (this.isExcludedCompany) return false;

    if (!window.ChurnZero) {
      console.warn('ChurnZero: Script not loaded yet');
      return false;
    }

    window.ChurnZero.push(['setContact', accountExternalId, contactExternalId]);
    this.isUserIdentified = true;

    if (user) {
      const contactAttributes = {};

      if (user.first_name) {
        contactAttributes.FirstName = user.first_name;
      }
      if (user.last_name) {
        contactAttributes.LastName = user.last_name;
      }
      if (user.email) {
        contactAttributes.Email = user.email;
      }
      if (user.phone_e164) {
        contactAttributes.PhoneE164 = user.phone_e164;
      }
      if (user.role) {
        contactAttributes.Role = user.role;
      }
      if (Array.isArray(user.scopes) && user?.scopes?.length > 0) {
        // Push active scopes to the Contact multi-select custom field
        contactAttributes.cf_ActiveScopes = user.scopes?.join(', ');
      }

      if (Object.keys(contactAttributes).length > 0) {
        window.ChurnZero.push(['setAttribute', 'contact', contactAttributes]);
      }

      const accountAttributes = {};

      if (user.company?.legal_name) {
        accountAttributes.Name = user.company.legal_name;
      }
      if (user.company?.id) {
        accountAttributes.CompanyId = user.company.id;
      }

      if (Object.keys(accountAttributes).length > 0) {
        window.ChurnZero.push(['setAttribute', 'account', accountAttributes]);
      }
    }

    return true;
  }

  /**
   * Track custom event
   * @param {string} eventName - Name of the event
   * @param {Object} properties - Event properties (optional)
   */
  trackEvent(eventName, properties = {}) {
    // Don't track events for excluded company (company ID 1)
    if (this.isExcludedCompany) {
      return false;
    }

    if (!this.isUserIdentified) return false;

    if (!window.ChurnZero) {
      console.warn('ChurnZero: Script not loaded yet');
      return false;
    }

    window.ChurnZero.push([
      'trackEvent',
      eventName,
      properties.description || '',
      1,
      properties,
    ]);
    return true;
  }

  /**
   * Check if ChurnZero is ready to use
   * @returns {boolean}
   */
  isReady() {
    return this.isInitialized && window.ChurnZero && this.appKey;
  }
}

const churnzeroService = new ChurnZeroService();
export default churnzeroService;
